var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"camera-status rounded-circle",class:{ 'camera-status--online': _vm.isCameraOnline }},[(_vm.cameraStatus)?_c('v-icon',{staticClass:"camera-status__icon",attrs:{"x-small":"","color":_vm.cameraStatusColor}},[_vm._v("\n    "+_vm._s(_vm.cameraStatusIcon)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }